__turbopack_context__.v({
  "badge": "WetC3W_badge",
  "btn-apply": "WetC3W_btn-apply",
  "btn-reset": "WetC3W_btn-reset",
  "container": "WetC3W_container",
  "controls": "WetC3W_controls",
  "flag-key": "WetC3W_flag-key",
  "flag-meta": "WetC3W_flag-meta",
  "flag-name": "WetC3W_flag-name",
  "header": "WetC3W_header",
  "input": "WetC3W_input",
  "list": "WetC3W_list",
  "overridden": "WetC3W_overridden",
  "override-count": "WetC3W_override-count",
  "panel": "WetC3W_panel",
  "reset-all": "WetC3W_reset-all",
  "row": "WetC3W_row",
  "select": "WetC3W_select",
  "server-value": "WetC3W_server-value",
  "title": "WetC3W_title",
  "toggle": "WetC3W_toggle",
});
